import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Routes } from 'src/app/constants/routes.constant';
import { BookingStepsEnum } from 'src/app/models/booking/enums/booking-steps.enum';
import { CommandEnum } from 'src/app/models/common/enums/command.enum';
import { FormStatusEnum } from 'src/app/models/common/enums/form-status.enum';
import { LogoButtonEnum } from 'src/app/models/shared/enums/logo-button.enum';
import { SignUpStoreRequest } from 'src/app/models/user/sign-up-store.model';
import { AlertService } from 'src/app/services/common/alert.service';
import { CommandService } from 'src/app/services/common/command.service';
import { AuthService } from 'src/app/services/user/auth.service';
import { SignupModelComponent } from '../signup-model/signup-model.component';
import { TypeDeliveryEnum } from 'src/app/models/user/enums/type-delivery.enum';
import { GoogleAnalyticsService } from 'src/app/services/common/google-analytics.service';

@Component({
    selector: 'app-sign-up-store',
    templateUrl: './sign-up-store.component.html',
    styleUrls: ['./sign-up-store.component.scss'],
    standalone: false
})
export class SignUpStoreComponent implements OnInit {

isMobile: boolean;
  logoTypeEnum: typeof LogoButtonEnum = LogoButtonEnum;
  redirect: string;
  redirectUrl: string;
  private readonly SessionID = 'Session-ID';
  working = false;
  valid: boolean;
  error: string;
  disabled: boolean;
  isUsed: boolean;
  step: BookingStepsEnum = BookingStepsEnum.Address;
  typeDelivery: string;
  isPasswordVisible: boolean;

  signupForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required, Validators.maxLength(30)]),
    lastName: new UntypedFormControl('', [Validators.required, Validators.maxLength(30)]),
    countryCode: new UntypedFormControl('', [Validators.required, Validators.pattern(`^(\\+\\d{1,4})$`)]),
    phone: new UntypedFormControl('', [Validators.required, Validators.pattern('^ *(?:[0-9] *){9,12}$')]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
    conditions:  new UntypedFormControl(0, Validators.requiredTrue),
    PrivacyPolicy: new UntypedFormControl(0 , Validators.requiredTrue),
    newsletter: new UntypedFormControl(0),
    referral: new UntypedFormControl('')
  });

  constructor(
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private alertService: AlertService,
    private commandService: CommandService,
    public dialog: MatDialog,
    private http: HttpClient,
    private cookieService: CookieService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.isUsed = false;
    this.isMobile = this.deviceService.isMobile();
    this.redirect = this.route.snapshot.queryParams.redirect;
    this.redirectUrl = this.redirect ? this.redirect : '/';
    this.isPasswordVisible = false;
    this.typeDelivery = this.route.snapshot.queryParams.store;
    if (TypeDeliveryEnum[this.typeDelivery]) {
      this.typeDelivery = TypeDeliveryEnum[this.typeDelivery];
    } else {
      this.router.navigate([Routes.GUEST.SIGN]);
    }
    this.signupForm.statusChanges.subscribe((status) => {
      this.error = null;
      this.valid = status === FormStatusEnum.Valid;
    });
  }

  getFieldFromForm(fieldName: string) {
    return this.signupForm.get(fieldName);
  }

  setCountryCodeValue(value) {
    const countryCodeField = this.getFieldFromForm('countryCode');

    countryCodeField.setValue(value);
  }

  showPassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  getReferralCode(): string {
    let code: string;

    this.route.params.subscribe((params) => {
      code = params.referralCode;
    });

    return code;
  }

  onFormSubmit() {
    this.disabled = false
    this.signup({
      Firstname: this.getFieldFromForm('firstName').value,
      Lastname: this.getFieldFromForm('lastName').value,
      countryCode: this.getFieldFromForm('countryCode').value,
      Phone: this.getFieldFromForm('countryCode').value+'|'+ this.getFieldFromForm('phone').value,
      EmailAddress: this.getFieldFromForm('email').value,
      Password: this.getFieldFromForm('password').value,
      AcceptPrivacy: this.getFieldFromForm('PrivacyPolicy').value ? 1 : 0,
      AcceptTerms:  this.getFieldFromForm('conditions').value ? 1 : 0,
      AcceptMarketing: this.getFieldFromForm('newsletter').value ? 1 : 0,
      TypeDelivery: this.typeDelivery,
      Referral :  this.getFieldFromForm('referral').value,
    });
  }

  signup(request: SignUpStoreRequest) {
    this.working = true;
    this.auth.checkEmail({EmailAddress: request.EmailAddress})
    .then(response => {
      this.auth
      .signup(request)
      .then(() => {
        this.auth
          .login({
            username: request.EmailAddress,
            password: request.Password
          })
          .then(() => {
            //this.saveDefaultPeferance();
            this.googleAnalyticsService.trackEvent('sign_up', {
              method: 'email',
              customer_type: 'new'
            }).catch(error => console.error('AddGa4Event sign_up failed: ', error));
            this.router.navigate([Routes.BOOKING_REGULAR.ADDRESS],{ queryParams: { store: this.typeDelivery } });
          });
      })
      .catch((err) => {
        console.error('Sign up failed: ', err);
        this.error = err.error.message;
        this.alertService.showError(this.error);
        this.working = false;
      });
    })
    .catch((err) => {
      this.isUsed = true;
      console.error('Sign up failed: ', err);
      this.error = err.error.error;
      this.alertService.showError(this.error);
      this.working = false;
    });
  }

  openDialogPrivacyPolicy() {
    this.dialog.open(SignupModelComponent, {
      data: {
        modal: 'PrivacyPolicy' ,
      },
    });
  }
  openDialogTermsandConditions(){
    this.dialog.open(SignupModelComponent, {
      data: {
        modal: 'TermsandConditions' ,
      },
    });
  }
  saveDefaultPeferance(){
    const pref = {
      InfoCustomerPreference: [
        { id_preference: 2, Titre: 'No care labels', Value: 'Upon request' },
        { id_preference: 7, Titre: 'Cleaning partner', Value: 'Always' }
      ]
    };
    this.commandService.executeUpdate(CommandEnum.SaveCustomerPreference, pref).then(
      (response) => {
      },
      (error) => { }
    );
  }
  redirectToLogin(){
    this.router.navigate(['/signinup']);
  }
}
